import { tns } from 'tiny-slider/src/tiny-slider'

if (document.querySelector('.page-template-opportunities')) {

  // Accordion
  var jobs = document.getElementsByClassName('job-title');

  for (var i = 0; i < jobs.length; i++) {
    jobs[i].addEventListener('click', function() {
      this.classList.toggle('active');
      
      var description = this.nextElementSibling;
      if (description.style.maxHeight) {
        description.style.maxHeight = null;
      } else {
        description.style.maxHeight = description.scrollHeight + 'px';
      } 
    });
  }

  // Image Gallery
  var slider = tns({
    container: '.section-gallery__gallery .slides',
    items: 1,
    slideBy: 'page',
    autoplay: true,
    autoplayButtonOutput: false,
    nav: false
  });
}
